import React, { FC, useReducer, createContext, useContext } from 'react';
import { TableRow } from '@code/innovance-react-ui-kit';

export enum ACTIONS {
  SEARCH_CUSTOMER,
  CLEAR,
}

interface CustomerSearchValues {
  customerSurname: string;
  customerName: string;
  customerSecondName: string;
  birthDate: Date | null;
  identityDocumentSerialCode: string;
  identityDocumentSerialNumber: string;
  selectedCustomer: TableRow;
}
interface ViewCreditsState {
  customerId?: string;
  customerNumber?: string;
  customerSearchValues?: CustomerSearchValues;
  customerPageNumber?: number;
}
type Action = { type: ACTIONS; payload?: any };
const viewCreditsReducer = (state: ViewCreditsState, action: Action): ViewCreditsState => {
  switch (action.type) {
    case ACTIONS.SEARCH_CUSTOMER:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.CLEAR:
      return initialValues;
    default:
      return state;
  }
};

type ViewCreditsDispatch = (action: Action) => void;
const ViewCreditsStateContext = createContext<ViewCreditsState | undefined>(undefined);
const ViewCreditsDispatchContext = createContext<ViewCreditsDispatch | undefined>(undefined);
const initialValues = {};

const ViewCreditsProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(viewCreditsReducer, initialValues);

  return (
    <ViewCreditsStateContext.Provider value={state}>
      <ViewCreditsDispatchContext.Provider value={dispatch}>
        {children}
      </ViewCreditsDispatchContext.Provider>
    </ViewCreditsStateContext.Provider>
  );
};
type SearchInput = Pick<
  ViewCreditsState,
  'customerId' | 'customerNumber' | 'customerSearchValues' | 'customerPageNumber'
>;
export const useCustomerSearchState = (): ViewCreditsState => {
  const context = useContext(ViewCreditsStateContext);
  if (context === undefined) {
    throw new Error('useCustomerSearchState must be used within a ViewCreditsProvider');
  }

  return context;
};
export const useCustomerSearchDispatch = (): ((payload: SearchInput) => void) => {
  const dispatch = useContext(ViewCreditsDispatchContext);
  if (dispatch === undefined) {
    throw new Error('useCustomerSearchDispatch must be used within a ViewCreditsProvider');
  }

  return (payload: SearchInput) => dispatch({ type: ACTIONS.SEARCH_CUSTOMER, payload });
};
export const useClearDispatch = (): (() => void) => {
  const dispatch = useContext(ViewCreditsDispatchContext);
  if (dispatch === undefined) {
    throw new Error('useClearDispatch must be used within a ViewCreditsProvider');
  }

  return () => dispatch({ type: ACTIONS.CLEAR });
};
export default ViewCreditsProvider;
